import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Box, Grid, IconButton, Typography } from '../mui/Core/index'
import LinkButton from '../LinkButton/link-button'
import { ArrowRightIcon } from '../mui/Icons'
import Constants from '../../constants/en.json'

function SummaryTablePagination({ totalRowsCount, rowsRenderedCount, route }) {
  const navigate = useNavigate()

  const clickHandle = () => {
    navigate(route)
  }

  const summaryTableStyle = { marginTop: '0px', px: '25px' }

  const rowsStyle = { mt: 4, mb: 2 }

  const seeAllStyle = { mt: 1, display: 'flex', justifyContent: 'flex-end' }

  const startCount = rowsRenderedCount > 0 ? 1 : 0

  const iconButtonStyle = { pl: 0, pr: 0 }

  return (
    <Box sx={summaryTableStyle}>
      <Grid container spacing={0}>
        <Grid size={{ xs: 6 }} sx={rowsStyle}>
          <Typography variant='body1'>
            {startCount}-{rowsRenderedCount} of {totalRowsCount} rows
          </Typography>
        </Grid>
        <Grid size={{ xs: 6 }} sx={seeAllStyle}>
          <LinkButton
            handleLinkClick={clickHandle}
            linkText={Constants.summaryTablePagination.SEE_ALL}
          />
          <IconButton sx={iconButtonStyle} onClick={clickHandle}>
            <ArrowRightIcon color='primary' />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  )
}

SummaryTablePagination.propTypes = {
  totalRowsCount: PropTypes.number.isRequired,
  rowsRenderedCount: PropTypes.number.isRequired,
  route: PropTypes.string.isRequired,
}

export default SummaryTablePagination
